import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
export const AccommodationSeparator = ({ className }: { className?: string }) => (
  <div className={classnames('flex items-center justify-center', className)}>
    <div className="m-0 block h-1 w-full border-0 border-t-1 border-dashed border-lightGrey p-0" />
    <div className="mx-10 inline-block rounded-12 bg-saffron px-15 py-10 text-24 font-bold leading-1 text-black">
      &
    </div>
    <div className="m-0 block h-1 w-full border-0 border-t-1 border-dashed border-lightGrey p-0" />
  </div>
);
